import {
  AutoLockFormsLevelType,
  ClosingSubsectionNames,
  LoanEditorSectionNames,
} from 'app/services/autoLockForms/autoLockForms.constants';

import { LoanApplicationTabName } from 'constants/loanApplication';

export const hiddenSubTabs = [LoanApplicationTabName.LOAN_SUMMARY];

export const ICON_SIZE = 20;

export const tabNameToAutoLockArea = {
  [LoanApplicationTabName.PROPERTY_AND_LOAN]: {
    name: LoanEditorSectionNames.PROPERTY_AND_LOAN,
    levelType: AutoLockFormsLevelType.SECTION,
  },
  [LoanApplicationTabName.BORROWERS]: {
    name: LoanEditorSectionNames.BORROWERS,
    levelType: AutoLockFormsLevelType.SECTION,
  },
  [LoanApplicationTabName.LOAN_FEES]: {
    name: LoanEditorSectionNames.FEES,
    levelType: AutoLockFormsLevelType.SECTION,
  },
  [LoanApplicationTabName.UNDERWRITING]: {
    name: LoanEditorSectionNames.UNDERWRITING,
    levelType: AutoLockFormsLevelType.SECTION,
  },
  [LoanApplicationTabName.UNDERWRITING_NEW]: {
    name: LoanEditorSectionNames.UNDERWRITING,
    levelType: AutoLockFormsLevelType.SECTION,
  },
  [LoanApplicationTabName.CLOSING_NEW]: {
    name: LoanEditorSectionNames.CLOSING,
    levelType: AutoLockFormsLevelType.SECTION,
  },
  [LoanApplicationTabName.POST_CLOSING]: {
    name: ClosingSubsectionNames.POST_CLOSING,
    levelType: AutoLockFormsLevelType.SUBSECTION,
  },
  [LoanApplicationTabName.FINANCIAL_INFO]: {
    name: LoanEditorSectionNames.FINANCIAL_INFO,
    levelType: AutoLockFormsLevelType.SECTION,
  },
};
